import React, { Component } from 'react'
import BulkEmailModal from './BulkEmailModal'
import { get, pick } from 'lodash'
import { message } from 'antd'
import Email from '../../../../api/Email'
import { arrVal } from '../../../../modules/Utils'

class BulkEmailCont extends Component {
  formRef = React.createRef()
  api = new Email()
  state = {
    email: {
      to: this.props.emails,
      cc: this.props.email.cc,
      bcc: this.props.email.bcc,
      from: this.props.email.from,
      subject: this.props.email.subject,
      attachments: this.props.email.attachments,
    },
    emails: this.props.emails || [],
    template: this.props.template,
  }

  send = async () => {
    const mail = await this.checkForm()
    try {
      this.setState({
        sending: true,
      })
      await this.api.bulk({
        ...mail,
        html: this.state.template,
        attachments: arrVal(mail, 'attachments').map((a) => get(a, 'response') || {}),
      })
      this.setState({
        sending: false,
      })
      message.success('Sent')
      this.props.onCancel()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        sending: false,
      })
    }
  }

  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }
  onChange = (e) => {
    this.setState({
      template: get(e, 'sender.body.innerHTML'),
    })
  }

  render() {
    return <BulkEmailModal {...this.props} {...this.state} {...pick(this, ['send', 'onChange', 'formRef'])} />
  }
}

BulkEmailCont.propTypes = {}
BulkEmailCont.defaultProps = { email: { attachments: [] } }

export default BulkEmailCont
